import { fromJS } from 'immutable';
import { normalizeRestDocument } from './DocumentsApi';
import { createRpcClientV2 } from 'rpc-client-utils';
import { listEntriesRpc } from '../../../../__generated__/chirp/com/hubspot/sales/documents/rpc/SalesDocumentIndexRpc';
import { mapDocumentEntry } from './mapDocumentEntry';
const DOCUMENTS_URI = 'salescontentsearch/v2/search';
// eslint-disable-next-line no-restricted-syntax
let savedCache;
// eslint-disable-next-line no-restricted-syntax
let cachedParams;

/**
 * Meant to be used in Unit / Integration tests only
 */
export const bustDocumentsCache = () => {
  savedCache = null;
  cachedParams = null;
};
const getPostBody = ({
  user_id,
  limit = 100,
  offset = 0,
  query = ''
}) => {
  const filters = [{
    field: 'content_type',
    values: ['DOCUMENT']
  }];
  if (user_id) {
    filters.push({
      field: 'user_id',
      values: [`${user_id}`]
    });
  }
  return {
    query,
    limit,
    offset,
    filters,
    contentTypesToHydrate: ['DOCUMENT', 'DOCUMENTS_FOLDER']
  };
};

/**
 *
 * @param {Object} options
 * @param {Object} options.httpClient - an http client containing a `post` method
 * @param {Object} options.cache - HS auth object with that contains a user object with a user_id
 * @returns {Promise}
 */
export function fetchDocuments({
  httpClient,
  auth,
  cache = true,
  queryParams = {}
}) {
  let promise;
  const shouldBustCache = cache && savedCache && cachedParams && fromJS(cachedParams).equals(fromJS(queryParams));
  if (shouldBustCache) {
    promise = Promise.resolve(savedCache);
    promise.catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
    return promise;
  }
  const user_id = auth ? auth.user.user_id : null;
  promise = httpClient.post(DOCUMENTS_URI, {
    data: getPostBody(Object.assign({}, queryParams, {
      user_id
    }))
  }).then(res => {
    const normalized = Object.assign({}, res, {
      results: res.results.map(normalizeRestDocument)
    });
    savedCache = normalized;
    cachedParams = queryParams;
    return normalized;
  }).catch(error => {
    return Promise.reject(error);
  });
  promise.catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
  return promise;
}

// eslint-disable-next-line no-restricted-syntax
let savedChirpCache;
// eslint-disable-next-line no-restricted-syntax
let cachedChirpParams;
export const bustDocumentsChirpCache = () => {
  savedChirpCache = null;
  cachedChirpParams = null;
};
export function fetchDocumentsCHIRP({
  httpClient,
  cache = true,
  queryParams = {}
}) {
  const {
    limit = 100,
    offset = 0
  } = queryParams;
  const cacheHit = cache && savedChirpCache && cachedChirpParams && fromJS(cachedChirpParams).equals(fromJS(queryParams));
  if (cacheHit) {
    return Promise.resolve(savedChirpCache);
  }
  const rpcClient = createRpcClientV2({
    hubHttpClient: httpClient
  });
  const promise = rpcClient.call(listEntriesRpc, {
    request: {
      entryTypes: ['DOCUMENT'],
      filters: [],
      pageLength: limit,
      offset
    }
  }).then(response => {
    var _response$results;
    const results = ((_response$results = response.results) !== null && _response$results !== void 0 ? _response$results : []).map(mapDocumentEntry).filter(item => item !== null);
    const mapped = {
      total: results.length,
      offset: response.offset,
      results
    };
    savedChirpCache = mapped;
    cachedChirpParams = queryParams;
    return mapped;
  });
  promise.catch(err => {
    setTimeout(() => {
      throw err;
    });
  });
  return promise;
}